import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable, tap, throwError } from 'rxjs';
import { LogInstanceToken, LogInterface } from '@evorait/pace-logging';
import { EnvironmentInstanceToken, PaceEnvironment } from '@evorait/pace-core';

@Injectable({
    providedIn: 'root',
})
export class ConfirmationComplaintsP58Service {
    public constructor(
        private readonly http: HttpClient,
        @Inject(LogInstanceToken) private readonly log: LogInterface,
        @Inject(EnvironmentInstanceToken) private readonly environment: PaceEnvironment,
    ) {}

    public saveComplaintParams(payload: { link: string }): Observable<{ id: string; message: string }> {
        const complaintsLinkAzureUrl = this.environment.complaintsLinkUrl;
        if (complaintsLinkAzureUrl) {
            return this.http.post<{ id: string; message: string }>(complaintsLinkAzureUrl, payload).pipe(
                tap((response) => {
                    this.log.info('Azure call success', response);
                }),
            );
        } else {
            this.log.error('complaintsLinkUrl is undefined');
            return throwError(() => new Error('complaintsLinkUrl is undefined'));
        }
    }
}
